export default __webpack_public_path__ + "static/payroll-for-teams-auto-salary-3a6b9aa303ea5418c77e2f877bbbdf30.png";